module.exports = __webpack_public_path__ + "img/marketing_sponsorship_fr.4bdaff0c.png";